import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import Select from "react-select"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import * as Yup from "yup"

//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle"

import CommonDialog from "components/Common/CommonDialog"
import {
  addPermission,
  editPermission,
  getModulesList,
  getOnePermission,
} from "../../helpers/UAM/permission.helper"
import { SystemConfigurationContext } from "context/systemConfigContext"

const AddPermission = props => {
  const navigate = useNavigate()
  const { inputMax } = useContext(SystemConfigurationContext)
  const { roleName } = JSON.parse(localStorage.getItem("user"))

  const location = useLocation()
  const pathnameSegments = location.pathname.split("/")
  const lastSegment = pathnameSegments[pathnameSegments.length - 1]

  //meta title
  let formattedLastSegment = lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1).toLowerCase();

  document.title = `${formattedLastSegment} Permission | DMS`

  const urlParams = new URLSearchParams(window.location.search)
  const encodedId = urlParams.get("id")
  const decodedId = atob(encodedId)

  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false })
  const [selectedMulti, setSelectedMulti] = useState([])
  const [permissionList, setPermissionList] = useState({})
  const [modulesList, setModulesList] = useState([])
  const [isCreate, setIsCreate] = useState(null)
  const [isEdit, setIsEdit] = useState(null)
  const [isView, setIsView] = useState(null)
  const [isList, setIsList] = useState(null)
  const [isUpload, setIsUpload] = useState(null)
  const [isDelete, setIsDelete] = useState(null)
  const [isApprove, setIsApprove] = useState(null)
  const [isReject, setIsReject] = useState(null)
  const [isFullAccess, setIsFullAccess] = useState(null)
  const [showViewTemplate, setShowViewTemplate] = useState(false)
  const [showEditTemplate, setShowEditTemplate] = useState(true)
  const [assignPermissionList, setAssignPermissionList] = useState([])

  function handleMulti(selectedMulti) {
    setSelectedMulti(selectedMulti)
    setIsCreate(null)
    setIsEdit(null)
    setIsView(null)
    setIsList(null)
    setIsUpload(null)
    setIsDelete(null)
    setIsApprove(null)
    setIsReject(null)
    setIsFullAccess(null)
    for (let selected of selectedMulti) {
      if (selected.value == "isCreate") {
        setIsCreate(1)
      } else if (selected.value == "isEdit") {
        setIsEdit(1)
      } else if (selected.value == "isView") {
        setIsView(1)
      }else if (selected.value == "isList") {
        setIsList(1)
      } else if (selected.value == "isUpload") {
        setIsUpload(1)
      } else if (selected.value == "isDelete") {
        setIsDelete(1)
      } else if (selected.value == "isApprove") {
        setIsApprove(1)
      } else if (selected.value == "isReject") {
        setIsReject(1)
      } else if (selected.value == "isFullAccess") {
        setIsFullAccess(1)
      }
    }
  }

  const optionGroup = [
    { label: "Is Create", value: "isCreate" },
    { label: "Is Edit", value: "isEdit" },
    { label: "Is View", value: "isView" },
    { label: "Is List", value: "isList" },
    { label: "Is Upload", value: "isUpload" },
    { label: "Is Delete", value: "isDelete" },
    { label: "Is Approve", value: "isApprove" },
    { label: "Is Reject", value: "isReject" },
    { label: "Is Fullaccess", value: "isFullAccess" },
  ]

  useEffect(() => {
    if (lastSegment == "view" || lastSegment == "edit") {
      getOnePermission({ permissionId: decodedId })
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 200) {
            let responseData = responseFromAPI.data
            setPermissionList(responseData)

            let values = []
            let assignValues = []

            if (responseData.isCreate) {
              values.push({ label: "Is Create", value: "isCreate" })
              assignValues.push("Create")
            }

            if (responseData.isEdit) {
              values.push({ label: "Is Edit", value: "isEdit" })
              assignValues.push("Edit")
            }

            if (responseData.isView) {
              values.push({ label: "Is View", value: "isView" })
              assignValues.push("View")
            }

            if (responseData.isList) {
              values.push({ label: "Is List", value: "isList" })
              assignValues.push("List")
            }

            if (responseData.isUpload) {
              values.push({ label: "Is Upload", value: "isUpload" })
              assignValues.push("Upload")
            }

            if (responseData.isDelete) {
              values.push({ label: "Is Delete", value: "isDelete" })
              assignValues.push("Delete")
            }

            if (responseData.isApprove) {
              values.push({ label: "Is Approve", value: "isApprove" })
              assignValues.push("Approve")
            }

            if (responseData.isReject) {
              values.push({ label: "Is Reject", value: "isReject" })
              assignValues.push("Reject")
            }

            if (responseData.isFullAccess) {
              values.push({ label: "Is Fullaccess", value: "isFullAccess" })
              assignValues.push("Fullaccess")
            }
            setAssignPermissionList(assignValues)
            handleMulti(values)
          }
        })
        .catch(error => {})
    }

    if (lastSegment == "view") {
      setShowViewTemplate(true)
      setShowEditTemplate(false)
    } else {
      setShowViewTemplate(false)
      setShowEditTemplate(true)
    }

    getModulesList()
      .then(response => {
        setModulesList(response?.data)
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      permissionName: permissionList.permissionName || "",
      permissionDisplayName: permissionList.permissionDisplayName || "",
      permissionDescription: permissionList.permissionDescription || "",
      assignPermission:
        (permissionList.isCreate && [permissionList.isCreate]) || [],
      module: permissionList.moduleId || "",
    },
    validationSchema: Yup.object({
      permissionName: Yup.string().required("Please Enter Permission Name"),
      permissionDisplayName: Yup.string().required(
        "Please Enter Permission Display Name"
      ),
      permissionDescription: Yup.string().required(
        "Please Enter permission Description"
      ),
      assignPermission: Yup.array().required("Please select an option"),
      module: Yup.string().required("Please select an option"),
    }),
    onSubmit: values => {
      const message =
        lastSegment == "edit"
          ? "Are you sure want to update permission?"
          : "Do you want to save entry?"
      setShowCommonDialog({ isShow: true, message: message })
    },
  })

  const navigateBack = () => {
    navigate(`/${roleName}/permission`)
  }

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      upsertPermissions()
    } else {
      setShowCommonDialog({ isShow: false })
    }
  }

  const upsertPermissions = () => {
    const { values } = validation
    if (lastSegment == "edit") {
      const updatePermission = {
        id: decodedId,
        permissionName: values.permissionName,
        permissionDisplayName: values.permissionDisplayName,
        permissionDescription: values.permissionDescription,
        moduleId: values["module"],
        isCreate: isCreate,
        isEdit,
        isView,
        isList,
        isUpload,
        isDelete,
        isApprove,
        isReject,
        isFullAccess,
      }
      // update permission
      editPermission(updatePermission)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            navigate(`/${roleName}/permission`)
          }
        })
        .catch(error => {})
      validation.resetForm()
    } else {
      const newPermission = {
        moduleId: values["module"],
        permissionName: values["permissionName"],
        permissionDisplayName: values["permissionDisplayName"],
        permissionDescription: values["permissionDescription"],
        isCreate: isCreate,
        isEdit,
        isView,
        isList,
        isUpload,
        isDelete,
        isApprove,
        isReject,
        isFullAccess,
      }
      addPermission(newPermission)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            navigate(`/${roleName}/permission`)
          }
        })
        .catch(error => {})

      validation.resetForm()
      setSelectedMulti([])
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid style={{marginBottom:'200px'}}>
          <Breadcrumbs title={`${lastSegment.toUpperCase()} PERMISSION`} />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  {showEditTemplate && (
                    <Form
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <Row>
                        <Col md='6' sm='12'>
                        <Label clacssName="form-label mt-2 required">Select a Module<span style={{color:'red'}}>*</span></Label>
                          <Input
                            name="module"
                            type="select"
                            placeholder="Select Module"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.module || ""}
                            invalid={
                              validation.touched.module &&
                              validation.errors.module
                            }
                          >
                            <option value="" disabled>
                              Choose a Module
                            </option>
                            {modulesList.map(elem => (
                              <option key={elem.id} value={elem.id}>
                                {elem.moduleDisplayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.module &&
                          validation.errors.module ? (
                            <FormFeedback type="invalid">
                              {validation.errors.module}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      
                      
                        <Col md={6} sm={12}>
                        <Label className=" form-label required">Permission Name</Label>
                          <Input
                            name="permissionName"
                            type="text"
                            maxLength={inputMax}
                            placeholder="Enter Permission Name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.permissionName || ""}
                            invalid={
                              validation.touched.permissionName &&
                              validation.errors.permissionName
                            }
                          />
                          {validation.touched.permissionName &&
                          validation.errors.permissionName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.permissionName}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      

                      
                        <Col md={6} sm={12}>
                        <Label className="form-label mt-2 required">Permission Display Name</Label>
                          <Input
                            name="permissionDisplayName"
                            type="text"
                            maxLength={inputMax}
                            placeholder="Enter Permission Display Name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={
                              validation.values.permissionDisplayName || ""
                            }
                            invalid={
                              validation.touched.permissionDisplayName &&
                              validation.errors.permissionDisplayName
                            }
                          />
                          {validation.touched.permissionDisplayName &&
                          validation.errors.permissionDisplayName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.permissionDisplayName}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      

                      
                        <Col md="6" sm="12">
                        <Label className="form-label mt-2 required">Permission Description</Label>
                          <Input
                            name="permissionDescription"
                            type="text"
                            maxLength={inputMax}
                            placeholder="Enter Permission Description"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={
                              validation.values.permissionDescription || ""
                            }
                            invalid={
                              validation.touched.permissionDescription &&
                              validation.errors.permissionDescription
                            }
                          />
                          {validation.touched.permissionDescription &&
                          validation.errors.permissionDescription ? (
                            <FormFeedback type="invalid">
                              {validation.errors.permissionDescription}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      

                      
                        <Col md="6" sm="12">
                        <Label className="form-label mt-2 ">Assign Permission</Label>
                          <Select
                            name="assignPermission"
                            value={selectedMulti}
                            isMulti={true}
                            onChange={selectedOptions => {
                              handleMulti(selectedOptions)
                            }}
                            options={optionGroup}
                            className={`select2-selection ${
                              !selectedMulti.length ? "is-invalid" : ""
                            }`}
                          />
                          {!selectedMulti.length ? (
                            <FormFeedback type="invalid">
                              {validation.errors.assignPermission}
                            </FormFeedback>
                          ) : null}
                        </Col>
                        </Row>
                      <Row>
                        <Col>
                          <div className="text-end">
                            <button
                              type="submit"
                              className="btn btn-outline-secondary me-2"
                              onClick={() => {
                                navigateBack()
                              }}
                            >
                              Back
                            </button>
                            <button
                              type="submit"
                              className="btn btn-success save-customer"
                            >
                              Save
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  )}
                  {showViewTemplate && (
                    <div>
                      <Row className="mb-4">
                        <Col sm={5}>
                          <Label className="col-sm-6 label-styling ">
                            Permission Name
                          </Label>
                          <p>{permissionList.permissionDisplayName || "-"}</p>
                        </Col>
                        <Col sm={5}>
                          <Label
                            htmlFor="horizontal-notification-Input"
                            className="col-sm-6 mb-0 label-styling "
                          >
                            Permission Description
                          </Label>
                          <p>{permissionList.permissionDescription || "-"}</p>
                        </Col>
                      </Row>
                      <Row className="mb-4">
                        <Col sm={5}>
                          <Label className="col-sm-6 label-styling ">
                            Assign Permissions
                          </Label>
                          <p>{assignPermissionList.join(",") || "-"}</p>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <div>
                            <button
                              className="btn btn-outline-secondary"
                              onClick={() => {
                                navigateBack()
                              }}
                            >
                              Back
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommonDialog && (
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message}
          data={showCommonDialog.data}
          postitiveBtn={"Submit"}
          negativeBtn={"Close"}
          onCloseFn={dialogAction}
        ></CommonDialog>
      )}
    </React.Fragment>
  )
}

AddPermission.propTypes = {
  history: PropTypes.object,
}

export default AddPermission
